"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = _interopRequireDefault(require("./Text"));
var _styles = require("../shared/styles");
var _jsxRuntime = require("react/jsx-runtime");
var Hexagon = _styledComponents.default.div.withConfig({
  displayName: "Avatar__Hexagon",
  componentId: "sc-1m7hkrd-0"
})(["position:relative;display:inline-block;width:calc(", " / 2 * 1.732);height:calc(", " / 2);background:", ";color:white;border-radius:", " / ", ";&:before,&:after{content:'';position:absolute;box-sizing:border-box;width:inherit;height:inherit;border-radius:inherit;background:inherit;left:0;}&:before{transform:rotate(60deg);}&:after{transform:rotate(-60deg);}"], function (props) {
  return _styles.avatarSize[props.size];
}, function (props) {
  return _styles.avatarSize[props.size];
}, _styles.colors.background.brand, _styles.borderRadius.s, _styles.borderRadius.m);
var HexagonWrapper = _styledComponents.default.div.withConfig({
  displayName: "Avatar__HexagonWrapper",
  componentId: "sc-1m7hkrd-1"
})(["width:calc(", " / 2 * 1.732);height:calc(", ");display:flex;justify-content:center;align-items:center;"], function (props) {
  return _styles.avatarSize[props.size];
}, function (props) {
  return _styles.avatarSize[props.size];
});
var TextWrapper = _styledComponents.default.div.withConfig({
  displayName: "Avatar__TextWrapper",
  componentId: "sc-1m7hkrd-2"
})(["display:flex;justify-content:center;align-items:center;position:absolute;z-index:1;width:100%;height:100%;"]);
var Image = _styledComponents.default.img.withConfig({
  displayName: "Avatar__Image",
  componentId: "sc-1m7hkrd-3"
})(["height:", ";"], function (props) {
  return _styles.avatarSize[props.size];
});
var Avatar = function Avatar(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: props.src ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Image, _objectSpread({
      crossOrigin: "use-credentials"
    }, props)) : /*#__PURE__*/(0, _jsxRuntime.jsx)(HexagonWrapper, _objectSpread({}, props, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Hexagon, _objectSpread({}, props, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(TextWrapper, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            type: 'heading',
            variant: props.size,
            color: 'light',
            children: props.initials
          })
        })
      }))
    }))
  });
};
exports.Avatar = Avatar;
Avatar.defaultProps = {
  size: 'm'
};